export const PricingPlan = [
  {
    title: "Basic",
    subtitle: "It is free forever",
    features: [
      "10 interview per/month",
      "List of 50 free Question",
      "20 Question per interview",
    ],
  },
  {
    title: "Regular",
    subtitle: "Best for small company",
    features: [
      "50 interview per/month",
      "List of 50 free Question",
      "20 Question per interview",
    ],
  },
  {
    title: "Enterpises",
    subtitle: "Best for enterprises",
    features: [
      "1000 interview per/month",
      "List of 500 free Question",
      "Unlimited Question per interview",
    ],
  },
];
